interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({ title, subtitle, actionLabel, actionHref }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500" aria-hidden="true" />
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-semibold tracking-wide text-foreground-950 uppercase">
            {title}
          </h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base" aria-hidden="true" />
        </a>
      )}
    </div>
  );
}